import _L from "../../../../util/Labels";
import { Fields, FormGenerator } from "../../../controlD3/Formulario";
import { ModalThingsUtil } from "../../../controlD3/ModalThings/Utils";
import { SelectV2 } from "../../../controlD3/SelectV2";
import { UIUtilFormat } from "../../../util/Format";
import { UIUtilGeneral } from "../../../util/Util";
import { UIUtilViewData } from "../../../util/ViewData";
import { AlumnoEdoCtaUtil } from "../AlumnoEdoCtaUtil";
import { AlEdoCtaPagoFormUtil } from "./Util";

import CTipoProcesoPago = AlEdoCtaPagoFormUtil.CTipoProcesoPago;

type AlumnoEdoCtaPagoFormConfig = AlEdoCtaPagoFormUtil.AlumnoEdoCtaPagoFormConfig;
type IBaseData = UIUtilViewData.IBaseData;
type IDataForm = AlEdoCtaPagoFormUtil.IDataForm;
type IMovimiento = AlEdoCtaPagoFormUtil.IMovimiento;
type IItemCargoPago = AlEdoCtaPagoFormUtil.IItemCargoPago;

const tipoPagosList = [
    { Id: CTipoProcesoPago.PagoSaldoTotal, Name: _L("panelfinanzasedocuenta.tag_paytotal") },
    { Id: CTipoProcesoPago.PagoSaldoPeriodo, Name: _L("panelfinanzasedocuenta.tag_payperiod") },
    { Id: CTipoProcesoPago.PagoParcial, Name: _L("panelfinanzasedocuenta.tag_paypartial") }
];

export class ProcesoPago1SelectChargesView {
    private container: HTMLDivElement;
    private formTipoPago: FormGenerator<IDataForm>;

    public get _Node(): HTMLDivElement {
        return this.container;
    }

    public get _FormTipoPago(): FormGenerator<IDataForm> {
        return this.formTipoPago;
    }

    constructor(
        private modalThings: ModalThingsUtil.IModalThings,
        private config: AlumnoEdoCtaPagoFormConfig,
        private procesoPagoFormData: AlEdoCtaPagoFormUtil.IDataForm,
        private fnUpdateProcesoPagoDataFromFormsData: () => void
    ) {
        const { modalThings: mt } = this;
        const { InfoGeneral: info } = this.config;

        this.container = document.createElement("div");
        this.container.className = "proceso_pago1_select_charges_view_container";

        const movimientosFaltoPagoList = info.MovimientosTbl_TopPeriodo
            .filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0));

        const movimientosPeriodoFaltoPagoList = info.MovimientosPeriodo
            .filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0));

        this.formTipoPago = new FormGenerator<IDataForm>()
        const formTipoPago = this.formTipoPago
        formTipoPago._Crear({
            LangModuleKeyInContext: AlumnoEdoCtaUtil.MODULO_LANG_KEY,
            LabelMaxWidth: 125,
            schema: [
                {
                    model: "TipoPago",
                    labelAttr: { text: "tag_paytype" },
                    type: Fields.selectMaterial,
                    selectMaterialAttr: {
                        required: true,
                        valueMember: "Id",
                        displayMember: "Name",
                        onSelect: (dato: IBaseData) => {
                            if (formTipoPago) {
                                this.UpdateFormTipoPago(dato?.Id, true);
                            }
                        },
                        // onChange: (id, dato: IBaseData) => {}
                    },
                    values: tipoPagosList
                },
                {
                    model: "IdsCargosParciales",
                    labelAttr: { text: "tag_chargestopay" },
                    type: Fields.selectMaterial,
                    selectMaterialAttr: {
                        valueMember: "Id",
                        displayMember: "Cargo",
                        multiselect: true,
                        required: false,
                        onSelect: (datos: IMovimiento[]) => {
                            mt.BtnRight._Enable(!!datos.length);
                            // console.log(datos);
                        },
                        // onChange: (a: number, b: IMovimiento[]) => {}
                        OnStepItemListUI: (container, data: IMovimiento, step) => {
                            let one = container.select(".one");
                            let two = container.select(".two");
                            let three = container.select(".three");
                            if (step == "enter") {
                                container.classed(UIUtilGeneral.FBoxOrientation.Vertical, true);
                                one = container.append("label").classed("one", true);
                                two = container.append("label").classed("two", true);
                                three = container.append("label").classed("three", true);
                            }
                            one.text(_L("panelfinanzasedocuenta.tag_period") + ": " + data.Periodo);
                            two.text(_L("panelfinanzasedocuenta.tag_descript") + ": " + data.Cargo);
                            three.text(_L("panelfinanzasedocuenta.d_field_saldo") + ": " + UIUtilFormat._CurrencyFmt(AlumnoEdoCtaUtil.GetSaldoMovimiento(data)));
                        },
                        OnChangeSearchText_GetDataValueToEval: (dato: IMovimiento) => `${dato.Periodo} ${dato.Cargo} ${UIUtilFormat._CurrencyFmt(AlumnoEdoCtaUtil.GetSaldoMovimiento(dato))}`,
                        ShowAndEnableSearchText: true,
                        ShowNSelectedInList: true
                    },
                    values: movimientosFaltoPagoList
                }
            ],
            // Validation: (val, field) => {
            //     if (field == "TipoPago") {
            //         return Boolean(val);
            //     }
            //     return true;
            // }
        }, procesoPagoFormData);


        // Deshabilita tipo de pago para el total del periodo, si no hay datos que cargos que pagar
        if (!movimientosPeriodoFaltoPagoList.length) {
            (formTipoPago._ControlsData.get("TipoPago").instance as SelectV2)
                ._disableItems(CTipoProcesoPago.PagoSaldoPeriodo);
        }

        // Inicializa vista del frm
        if (config.PreSeleccionados.length) {
            this.UpdateFormTipoPago(procesoPagoFormData.TipoPago, false);
        } else {
            this.UpdateFormTipoPago(null);
        }

        this.container.appendChild(formTipoPago._Form.node());
    }

    public _DrawView(): HTMLDivElement {
        return this.container;
    }

    public _Valide(): boolean {
        const { config,
            formTipoPago,
            procesoPagoFormData: procesoPagoData,
            fnUpdateProcesoPagoDataFromFormsData } = this;

        const movimientosFaltoPagoList = config.InfoGeneral.MovimientosTbl_TopPeriodo
            .filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0));

        const movimientosPeriodoFaltoPagoList = config.InfoGeneral.MovimientosPeriodo
            .filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0));

        const formIsValid = formTipoPago._GetIsValidForm();

        if (formIsValid) {
            fnUpdateProcesoPagoDataFromFormsData();

            // Ajusta los cargos a pagar antes de pasar a la vista siguiente
            procesoPagoData.CargosToPay = [];

            switch (formTipoPago._Data.TipoPago) {
                case CTipoProcesoPago.PagoSaldoTotal:
                    procesoPagoData.CargosToPay = movimientosFaltoPagoList
                        .map<IItemCargoPago>(d => ({
                            Cargo: d,
                            Pago: AlumnoEdoCtaUtil.GetSaldoMovimiento(d)
                        }))
                    break;
                case CTipoProcesoPago.PagoSaldoPeriodo:
                    procesoPagoData.CargosToPay = movimientosPeriodoFaltoPagoList
                        .map<IItemCargoPago>(d => ({
                            Cargo: d,
                            Pago: AlumnoEdoCtaUtil.GetSaldoMovimiento(d)
                        }));
                    break;
                case CTipoProcesoPago.PagoParcial:
                    const ctrlSelectCargos = (formTipoPago._ControlsData.get("IdsCargosParciales").instance as unknown as SelectV2<IMovimiento, "Id", "multiselect">);

                    procesoPagoData.CargosToPay = ctrlSelectCargos._dataSelected
                        .map(d => ({
                            Cargo: d,
                            Pago: AlumnoEdoCtaUtil.GetSaldoMovimiento(d)
                        }))
                    break;
            }
            console.warn("-d", "procesoPagoData", procesoPagoData);
            return Boolean(procesoPagoData.CargosToPay.length);
        }

        return false;
    }

    // ****************************************************************************
    // PRIVATE METHODS
    // ****************************************************************************

    private UpdateFormTipoPago(idTipoPago: CTipoProcesoPago, expandChargesList: boolean = false): void {
        const { modalThings: mt, formTipoPago } = this;

        const esPagoParcial = (idTipoPago == CTipoProcesoPago.PagoParcial);
        const formRowCargosParciales = formTipoPago._ControlsData.get("IdsCargosParciales");

        let selectPagosParciales = formTipoPago._ControlsData.get("IdsCargosParciales").selection;
        selectPagosParciales.attr("required", esPagoParcial ? "" : null);

        formRowCargosParciales.row
            .classed("hide", !esPagoParcial);

        if (!esPagoParcial) {
            mt.BtnRight._Enable(!!idTipoPago);
        } else if (expandChargesList) {
            (formRowCargosParciales.instance as SelectV2)
                ._ResetSelect()
                ._showOptionsList();
        }
    }
}